import { useEffect, useRef } from "react";
import { Trash2 } from "lucide-react";
import { ErrorMessage } from "./Loading";

export default function DeleteConfirmation({
  title,
  description,
  kicker = "Permanent action",
  confirmLabel,
  busyLabel = "Deleting…",
  busy = false,
  error = "",
  onCancel,
  onConfirm,
}) {
  const dialog = useRef(null);

  useEffect(() => {
    dialog.current?.focus();
  }, []);

  useEffect(() => {
    const closeOnEscape = (event) => event.key === "Escape" && !busy && onCancel();
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [busy, onCancel]);

  return (
    <div className="modal-backdrop delete-confirmation-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && !busy && onCancel()}>
      <section className="delete-confirmation" role="alertdialog" aria-modal="true" aria-labelledby="delete-confirmation-title" aria-describedby="delete-confirmation-description" tabIndex="-1" ref={dialog}>
        <div className="delete-confirmation__icon"><Trash2 aria-hidden="true" /></div>
        <p className="kicker">{kicker}</p>
        <h2 id="delete-confirmation-title">{title}</h2>
        <p id="delete-confirmation-description">{description}</p>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <div className="delete-confirmation__actions">
          <button className="button button--ghost" type="button" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="button button--danger" type="button" onClick={onConfirm} disabled={busy}>{busy ? busyLabel : confirmLabel} <Trash2 aria-hidden="true" /></button>
        </div>
      </section>
    </div>
  );
}
